import {
  Disclaimer,
  Div,
  H5,
  ReceivablesLocation,
  displayCentsInDollars,
  lightTheme,
} from '@vgrubs/components';
import { formatDay } from '../helpers/receivablesLabels';
import { MobileLabel } from './MobileLabel';
import { PhoneCardDetails, PhoneCardLabel } from './PhoneCardDetails';
import { InactiveTag, LocationNameLink, OwnerName } from './ReceivablesCells';
import {
  BankStatus,
  OldVDriveDebt,
  OwedBreakdown,
  SaasVisibility,
} from './ReceivablesLocationValues';

/**
 * A receivables location on a phone. What it owes sits top right, across
 * from the name, so a scroll down the list reads the amounts the way the
 * desktop's last column does; the rest is a column of labels with the
 * values lined up beside them, one row per desktop column.
 */
export const ReceivablesLocationCard = ({
  row,
}: {
  row: ReceivablesLocation;
}) => (
  <Div $mobile $width="100%" $minWidth="0">
    <Div $flex $alignStart $between $gap="16px">
      <Div $flex $column $gap="4px" $minWidth="0">
        <LocationNameLink locationId={row.locationId} name={row.locationName} />
        {row.deleted && <InactiveTag />}
        <Div $flex $alignCenter $gap="4px" $minWidth="0">
          <MobileLabel>Owner</MobileLabel>
          <OwnerName name={row.ownerName} />
        </Div>
      </Div>
      {/* Never shrinks: the name is the part that gives way. */}
      <Div $flex $column $alignEnd $gap="4px" style={{ flex: 'none' }}>
        <H5 $m="0" $color={row.total > 0 ? lightTheme.primary : undefined}>
          {displayCentsInDollars(row.total)}
        </H5>
        {row.oldestItemAt && (
          <Disclaimer $m="0" $noWrap $color={lightTheme.lightGray}>
            Oldest {formatDay(row.oldestItemAt)}
          </Disclaimer>
        )}
      </Div>
    </Div>

    <PhoneCardDetails>
      <PhoneCardLabel>Debt by Service</PhoneCardLabel>
      <Div $flex $column $gap="2px" $minWidth="0">
        <OwedBreakdown row={row} />
      </Div>

      <PhoneCardLabel>Previous Transaction Due Balance</PhoneCardLabel>
      <OldVDriveDebt row={row} />

      <PhoneCardLabel>Bank</PhoneCardLabel>
      <BankStatus row={row} />

      <PhoneCardLabel>SaaS</PhoneCardLabel>
      <SaasVisibility row={row} />
    </PhoneCardDetails>
  </Div>
);
